import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SafeSubscribable } from 'src/app/core/rxjs/extensions';
import { QuizQuestion } from 'src/app/models';

@Component({
  selector: 'app-question-form',
  templateUrl: './question-form.component.html',
  styleUrls: ['./question-form.component.css']
})
export class QuestionFormComponent implements OnInit, OnChanges, OnDestroy, SafeSubscribable {

  salt = '_' + Math.round(Math.random() * 100000);

  // Variables
  @Input() question!: QuizQuestion;
  @Input() questionNumber!: number;
  @Input() answer?: number;
  form!: FormGroup;

  // Emit event when user selects an option
  @Output() onChoiceMade = new EventEmitter<number>();

  // Needed  this to display option letters
  letterArray: String[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

  constructor() { }

  ngOnInit(): void {

    // Initialize formgroup
    this.form = new FormGroup({
      choice: new FormControl([this.answer])
    });

    this.form.valueChanges.safeSubscribe(this, this.onChange);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.answer && changes.answer.currentValue >= 0) {
      this.form.patchValue({
        choice: changes.answer.currentValue
      });
    }
  }

  ngOnDestroy(): void {}

  // Choice changed
  onChange = () => {
    this.onChoiceMade.emit(this.form.value.choice);
  }
}
